import { X } from "@phosphor-icons/react";
import { cn } from "@/lib/cn";

export interface TagProps {
  children: React.ReactNode;
  onRemove?: () => void;
  className?: string;
}

/** Static/removable tag — DESIGN.md §9 board example: "Roblox ✕, Asset, UI, Hiring". */
export const Tag = forwardRef<HTMLSpanElement, TagProps>(function Tag({ children, onRemove, className }, ref) {
  return (
    <span
      ref={ref}
      className={cn(
        "inline-flex h-6 items-center gap-1 rounded-xs border border-border bg-surface-2 px-2 text-small text-text-secondary",
        className,
      )}
    >
      {children}
      {onRemove && (
        <button
          type="button"
          onClick={onRemove}
          aria-label={`Remove ${typeof children === "string" ? children : "tag"}`}
          className="ml-0.5 rounded-xs text-text-muted hover:text-text-primary focus-visible:outline-2 focus-visible:outline-primary"
        >
          <X size={12} weight="regular" aria-hidden="true" />
        </button>
      )}
    </span>
  );
});
import { forwardRef } from "react";
